
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-665c51a3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewPatient.scp.html")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewPatient.scp.html"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-665c51a3\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewPatient.scp.html"),
  /* scopeId */
  "data-v-665c51a3",
  /* cssModules */
  null
)
Component.options.__file = "C:\\Products\\VCare\\Sourcecode\\branches\\PROD\\VCarePortal\\PharmacyPortal\\ClientApp\\components\\FmdControls\\Patients\\NewPatient.scp.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NewPatient.scp.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-665c51a3", Component.options)
  } else {
    hotAPI.reload("data-v-665c51a3", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/components/FmdControls/Patients/NewPatient.scp.html
// module id = 36
// module chunks = 0